<template>
  <div class="text-center">
    <div class="vx-col" v-if="success">
      <vs-alert color="success" title="Verstuurd" active="true">
        We hebben je verzoek binnengekregen om het termijnbedrag aan te passen.
        Je ontvangt bericht wanneer het daadwerkelijk is aangepast.
      </vs-alert>
    </div>
    <div v-if="!success">
      <vs-alert
        color="warning"
        title="Niet mogelijk om een advies te krijgen"
        v-if="advise.show_advise == -1"
      >
        <div
          v-if="
            customerStatus.has_conventional_meter &&
              !advise.conventional_show_meterreading_request
          "
        >
          Er kan geen advies over je termijnbedrag gegeven worden. Dit kan te
          maken hebben met ontbrekende meetgegevens, neem contact op met
          <a href="mailto:service@naked-energy.nl">service@naked-energy.nl</a>
          om uit te laten zoeken waarom je geen advies over je termijnbedrag kan
          krijgen.
        </div>
        <div v-else>
          Er kan geen advies over je termijnbedrag gegeven worden. Dit kan één
          van de volgende redenen hebben:
          <ul class="pl-base pt-4 mb-base" style="list-style-type: initial;">
            <li>
              Je bent nog niet lang genoeg klant bij ons. Je moet minimaal 2
              maanden klant zijn, zodat we genoeg data hebben om een goed advies
              uit te kunnen brengen.
            </li>
            <li v-if="customerStatus.has_smart_meter">
              Er is een storing in je slimme meter waardoor er geen data over je
              verbruik verzameld kan worden.
            </li>
            <li>
              Je meter is in de tussentijd vervangen.
            </li>
            <li
              v-if="
                customerStatus.has_conventional_meter &&
                  advise.conventional_show_meterreading_request
              "
            >
              Je hebt geen slimme meter of één van je meters is conventioneel.
              In dit geval moet je handmatig je recentste meterstanden
              doorgeven:
              <div class="vx-row">
                <div class="vx-col ml-auto mr-auto xl:w-1/2 m-2">
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    :href="`/app/${advise.contract_id}/meterreadingrequest`"
                    >Geef je recentste meterstanden door</vs-button
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </vs-alert>

      <vs-alert
        color="success"
        title="Advies"
        class="mb-base"
        v-if="advise.show_advise == 0"
      >
        Je termijnbedrag past goed bij je verbruik, deze hoef je dus niet aan te
        passen.
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full xl:w-1/2 ml-auto mr-auto">
          <vs-alert
            color="primary"
            title="Advies"
            class="mb-base hacky-height"
            v-if="advise.show_advise > 0"
          >
            <p>
              We adviseren om je termijnbedrag aan te passen van
              <b>
                <money-format
                  style="display: inline-block;"
                  v-if="current"
                  :value="current"
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"
              /></b>
              naar
              <b>
                <money-format
                  style="display: inline-block;"
                  v-if="advise.new_recurring_amount"
                  :value="advise.new_recurring_amount"
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"/></b
              >.
              <span v-if="advise.global_start_date"
                >Dit is gebaseerd op de periode van
                {{ advise.global_start_date | date }} tot
                {{ advise.global_end_date | date }}, deze periode komt overeen
                met ongeveer
                {{ advise.global_percentage_of_uac | percentage }} van je totale
                jaarverbruik.</span
              >
            </p>

            <p class="pt-4" v-if="advise.surplus_recurring_amount > 0">
              Je huidige verbruik is nu hoger dan waar je termijnbedrag destijds
              op gebaseerd is. Hierdoor heb je afgelopen maanden te weinig
              betaald. Om te zorgen dat je niet te veel moet bijbetalen bij je
              eind-/jaarnota, is een bedrag van
              <b>
                <money-format
                  style="display: inline-block;"
                  v-if="advise.surplus_recurring_amount"
                  :value="advise.surplus_recurring_amount"
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"
              /></b>
              hierbij opgeteld. Het daadwerkelijke termijnbedrag dat past bij je
              huidige verbruik is
              <b>
                <money-format
                  style="display: inline-block;"
                  v-if="advise.surplus_recurring_amount"
                  :value="
                    advise.new_recurring_amount -
                      advise.surplus_recurring_amount
                  "
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"
                />
              </b>
            </p>

            <p
              v-for="disclaimer in advise.disclaimers"
              class="pt-4"
              :key="disclaimer"
            >
              {{ disclaimer }}
            </p>

            <div class="text-center">
              <vs-button
                color="success"
                type="filled"
                class="mt-2 xl:w-1/2 "
                @click="submitAdvised"
                >Neem dit advies over en pas mijn termijnbedrag aan naar
                <money-format
                  style="display: inline-block;"
                  v-if="advise.new_recurring_amount"
                  :value="advise.new_recurring_amount"
                  locale="nl"
                  currency-code="EUR"
                  :subunit-value="true"
                  :hide-subunits="false"
              /></vs-button>
            </div>
            <p
              class="pt-4 text-italic"
              v-if="advise.expected_usages.length > 0"
            >
              Een gedetailleerde weergave per aansluiting en tariefsoort is hier
              beneden te vinden.
            </p>
            <div v-else class="m-2">
              Het zou kunnen zijn dat je verbruik in de tussentijd veranderd is.
              Geef je recentste meterstanden door, zodat we een nog betere
              inschatting kunnen maken van je termijnbedrag.
              <div class="vx-row">
                <div class="vx-col ml-auto mr-auto xl:w-1/2 m-2">
                  <vs-button
                    color="primary"
                    icon-pack="feather"
                    :href="`/app/${advise.contract_id}/meterreadingrequest`"
                    >Geef je recentste meterstanden door</vs-button
                  >
                </div>
              </div>
            </div>
          </vs-alert>
        </div>
      </div>
      <div class="vx-row" v-if="advise.show_advise > 0">
        <div class="vx-col w-full xl:w-3/4 ml-auto mr-auto mb-base">
          <vx-card title="Details" v-if="advise.expected_usages.length > 0">
            <vs-collapse>
              <vs-collapse-item
                v-for="expected_usage in advise.expected_usages"
                :key="expected_usage.type"
              >
                <div slot="header">
                  {{ $t(`Producttypes.${expected_usage.type}`) }}
                </div>
                <vs-table
                  :data="expected_usage.usage"
                  noDataText="Geen aansluitingen aanwezig"
                >
                  <template slot="thead">
                    <vs-th>Tariefsoort</vs-th>
                    <vs-th>Oudste meterstanddatum</vs-th>
                    <vs-th>Recentste meterstanddatum</vs-th>
                    <vs-th
                      >Oudste meterstand ({{
                        $t(`Productunity.${expected_usage.type}`)
                      }})</vs-th
                    >
                    <vs-th
                      >Recentste meterstand ({{
                        $t(`Productunity.${expected_usage.type}`)
                      }})</vs-th
                    >
                    <vs-th
                      >Verbruik in deze periode ({{
                        $t(`Productunity.${expected_usage.type}`)
                      }})</vs-th
                    >
                    <vs-th>Percentage van het jaarverbruik</vs-th>
                    <vs-th>Huidig jaarverbruik</vs-th>
                    <vs-th>Verwacht jaarverbruik</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td :data="data[indextr].tariff_type_display_name">
                        {{ data[indextr].tariff_type_display_name }}
                      </vs-td>
                      <vs-td :data="data[indextr].date">
                        {{ data[indextr].start_date | date }}
                      </vs-td>
                      <vs-td :data="data[indextr].date">
                        {{ data[indextr].end_date | date }}
                      </vs-td>
                      <vs-td :data="data[indextr].start_metering">
                        {{ data[indextr].start_metering }}
                      </vs-td>
                      <vs-td :data="data[indextr].end_metering">
                        {{ data[indextr].end_metering }}
                      </vs-td>
                      <vs-td :data="data[indextr].usage_in_period">
                        {{ data[indextr].usage_in_period }}
                      </vs-td>
                      <vs-td :data="data[indextr].percentage_of_uac">
                        {{ data[indextr].percentage_of_uac | percentage }}
                      </vs-td>
                      <vs-td :data="data[indextr].percentage_of_uac">
                        <b>{{ data[indextr].current_usage | round }}</b>
                      </vs-td>
                      <vs-td :data="data[indextr].percentage_of_uac">
                        <b>{{
                          (data[indextr].percentage_of_uac == 0
                            ? "-"
                            : data[indextr].expected_usage) | round
                        }}</b>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-collapse-item>
            </vs-collapse>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";
import moment from "moment";
import axios from "@/axios";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["customerStatus"])
  },
  data() {
    return { success: false };
  },
  props: ["advise", "current"],
  components: {
    MoneyFormat
  },
  methods: {
    async created() {},
    async submitAdvised() {
      try {
        await axios().put("/api/contracts/recurring_amount", {
          contract_id: this.advise.contract_id,
          amount: this.advise.new_recurring_amount,
          advise_key: this.advise.advise_key
        });
        this.success = true;
      } catch (err) {
        this.amountErrors = err.response.data;
      }
      this.sentLoading = false;
    }
  },
  filters: {
    date: function(date) {
      return moment(date)
        .locale("nl")
        .format("LL");
    },
    percentage: function(percentage) {
      if (percentage) {
        return `${Math.round(percentage * 100)}%`;
      }
    },
    round: function(uac) {
      if (uac != "-") {
        return Math.round(uac);
      }
      return uac;
    }
  }
};
</script>
<style scoped>
.hacky-height {
  height: initial !important ;
}
</style>
